import React from 'react';
import './sidebar.scss';
import clsx from 'clsx';
import Drawer from '@material-ui/core/Drawer';
import { makeStyles } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';


import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import BackupOutlinedIcon from '@material-ui/icons/BackupOutlined';
import PersonOutlinedIcon from '@material-ui/icons/PersonOutlined';
import DashboardIcon from '@material-ui/icons/Dashboard';

import logo from '../../../assets/images/company.jpg'
import { Link } from 'react-router-dom';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(6) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(8) + 1,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
}));

const Sidebar = () => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };
    return (
        <div onMouseLeave={handleDrawerClose}
            onMouseEnter={handleDrawerOpen}>

            <Drawer
                variant="permanent"
                className={clsx(classes.drawer, {
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                })}
                classes={{
                    paper: clsx({
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    }),
                }}>

                <List>

                    {
                        <Link to="/">

                            <div className="logo">
                                <img className="icon" src={logo} alt='company' />
                            </div>
                        </Link>

                    }
                    {/* <Divider /> */}

                    {<ListItem button key={'DASHBOARD'}>
                        <ListItemIcon>
                            <DashboardIcon style={{ color: '#a0148c', fontSize: 30 }} /></ListItemIcon>
                        <ListItemText primary={'DASHBOARD'} />
                    </ListItem>}
                    {<ListItem button key={'TEMPLATE BINDING'}>
                        <ListItemIcon>
                            <AssignmentOutlinedIcon style={{ color: '#a0148c', fontSize: 30 }} /></ListItemIcon>
                        <ListItemText primary={'TEMPLATE BINDING'} />
                    </ListItem>}
                    {
                        <Link to="/bkp">
                            <ListItem button key={'BACKUP'}>
                                <ListItemIcon> <BackupOutlinedIcon style={{ color: '#a0148c', fontSize: 30 }} /></ListItemIcon>
                                <ListItemText primary={'BACKUP'} />
                            </ListItem>
                        </Link>
                    }
                    {<ListItem button key={'CUSTOMER'}>
                        <ListItemIcon> <PersonOutlinedIcon style={{ color: '#a0148c', fontSize: 30 }} /></ListItemIcon>
                        <ListItemText primary={'CUSTOMER'} />
                    </ListItem>}
                </List>
            </Drawer>
        </div>
    );
}

export default Sidebar;